import React from "react";
import { successErrorType } from "../../../cache/cache";

import "./styles.css";

interface IButton {
    className?: string;
    errors: successErrorType | successErrorType[];
}

const ErrorMessage: React.FC<IButton> = ({ className = "", errors }) => {
    return (
        <div
            className={`error-message ${className}`}
            data-testid="error-testid"
        >
            {Array.isArray(errors)
                ? errors.map((err, i) => {
                      return (
                          <React.Fragment key={i}>
                              {err.message}
                              <br />
                          </React.Fragment>
                      );
                  })
                : errors.message}
        </div>
    );
};

export default ErrorMessage;
